'use strict';

var Reflux = require('reflux');
var router = require('routers/main');

/* Actions */
var ProjectActions = require('actions/project');

/* API */
var ProjectApi = require('api/project');

/* Stores */
var AuthStore = require('stores/authentication');

var ProjectStore = Reflux.createStore({
  listenables: [ProjectActions],

  init: function init() {
    var store = this;

    store.loading = true;
    store.projects = [];
    store.position = { x: 0, y: 0 };
  },

  getInitialState: function getInitialState() {
    return this.projects;
  },

  onLoadAll: function onLoadAll() {
    var _this = this;

    ProjectApi.load().done(function (data) {
      _this.projects = data;
      _this.loading = false;
      _this.trigger(_this.projects);
    });
  },

  onStartDragging: function onStartDragging(projectId, x, y) {
    var store = this;
    var projects = store.projects;

    var project = projects.find(function (project) {
      return project.id === projectId;
    });

    store.dragging = true;

    store.drag = {
      project: project,
      offset: { x: x, y: y },
      original: { x: project.position.x, y: project.position.y }
    };

    store.trigger(projects);
  },

  onUpdateDrag: function onUpdateDrag(x, y) {
    var store = this;
    var drag = store.drag;

    if (store.drag) {
      var project = drag.project;
      var offset = drag.offset;
      var original = drag.original;

      project.position.x = original.x + (x - offset.x);
      project.position.y = original.y + (y - offset.y);

      store.position = { x: project.position.x, y: project.position.y };

      window.requestAnimationFrame(function () {
        store.trigger(store.projects);
      });
    }
  },

  onStopDragging: function onStopDragging() {
    var store = this;

    store.dragging = false;
    store.drag = null;
    store.trigger(store.projects);
  },

  onAssignTeam: function onAssignTeam(projectId, teamId) {
    var store = this;
    var projects = store.projects;

    var project = projects.find(function (project) {
      return project.id === projectId;
    });
    var teams = project.teams;

    if (project.teams.some(function (team) {
      return team.teamId === teamId;
    })) {
      return;
    }

    teams.push({ teamId: teamId, role: 'reviewer' });

    ProjectApi.update(projectId, { teams: teams });

    store.trigger(projects);
  },

  onUnassignTeam: function onUnassignTeam(projectId, teamId) {
    var store = this;
    var projects = store.projects;

    var project = projects.find(function (project) {
      return project.id === projectId;
    });

    if (!project.teams.some(function (team) {
      return team.teamId === teamId;
    })) {
      return;
    }

    project.teams = project.teams.filter(function (team) {
      return team.teamId !== teamId;
    });

    ProjectApi.update(projectId, { teams: project.teams });

    store.trigger(projects);
  },

  onAssignUser: function onAssignUser(projectId, userId) {
    var store = this;
    var projects = store.projects;

    var project = projects.find(function (project) {
      return project.id === projectId;
    });
    var users = project.users;

    if (project.users.some(function (user) {
      return user.userId === userId;
    })) {
      return;
    }

    users.push({ userId: userId, role: 'reviewer' });

    ProjectApi.update(projectId, { users: users });

    store.trigger(projects);
  },

  onUnassignUser: function onUnassignUser(projectId, userId) {
    var store = this;
    var projects = store.projects;

    var project = projects.find(function (project) {
      return project.id === projectId;
    });

    if (!project.users.some(function (user) {
      return user.userId === userId;
    })) {
      return;
    }

    project.users = project.users.filter(function (user) {
      return user.userId !== userId;
    });

    ProjectApi.update(projectId, { users: project.users });

    store.trigger(projects);
  },

  changeUserRole: function changeUserRole(projectId, userId, role) {
    var store = this;
    var projects = store.projects;

    var project = projects.find(function (project) {
      return project.id === projectId;
    });

    var user = project.users.find(function (user) {
      return user.id === userId;
    });

    user.role = role;

    store.trigger(projects);
  },

  onCreate: function onCreate(props) {
    var _this2 = this;

    var userId = AuthStore.user.id;
    props.users = [{ userId: userId, role: 'owner' }];

    ProjectApi.add(props).done(function (data) {
      _this2.projects.unshift(data);
      _this2.trigger(_this2.projects);
    });
  },

  onDelete: function onDelete(projectId) {
    var _this3 = this;

    router.transitionTo('/');

    ProjectApi['delete'](projectId).done(function () {
      _this3.projects = _this3.projects.filter(function (project) {
        return project.id !== projectId;
      });
      _this3.trigger(_this3.projects);
    });
  },

  onEdit: function onEdit(id, props) {
    var _this4 = this;

    ProjectApi.update(id, props).done(function (newProject) {
      // Exchange the new project for the old project
      _this4.projects = _this4.projects.map(function (project) {
        return project.id === id ? newProject : project;
      });
      _this4.trigger(_this4.projects);
    });
  },

  onCopy: function onCopy(id, props) {
    var _this5 = this;

    router.transitionTo('/');

    ProjectApi.copy(id, props).done(function (project) {
      _this5.position = { x: 0, y: 0 };
      _this5.projects.splice(0, 0, project);
      _this5.trigger(_this5.projects);

      router.transitionTo('/project/' + project.id);
    });
  },

  onLeave: function onLeave() {
    this.position = { x: 0, y: 0 };
  }

});

module.exports = ProjectStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/project.js
 **/